module.exports = __webpack_public_path__ + "img/badge-5.0898e16e.svg";